import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  caseAlertDetails: {
    wordBreak: 'break-word',
    '.kvResponsive': {
      width: '50%',
      [theme.breakpoints.down('md')]: {
        width: '100%'
      }
    }
  }
}));

export default useStyles;
